@let card = data();
<big-ui-card [hasLink]="!!card.link">
    <div
        *transloco="let t; prefix: 'uiCard'"
        class="flex gap-4"
        [ngClass]="classList">
        <h5
            class="mb-0! flex gap-4"
            [class.flex-col]="!iconLeft()"
            [class.items-center]="iconLeft()">
            @if (card.svgIcon; as svgIcon) {
                <big-ui-svg-icon
                    [url]="svgIcon"
                    [ngClass]="iconSvgCssClass()" />
            } @else if (card.icon) {
                <big-icon
                    [icon]="card.icon!"
                    [size]="iconSize()"
                    [ngClass]="iconCssClass()" />
            }
            {{ card.title }}
        </h5>
        @if (card.text) {
            <p
                class="grow mb-0!"
                [innerHTML]="card.text | nl2br | sanitize: securityContext"></p>
        }
        <big-ui-card-link
            [class.-mt-4]="hideLink()"
            [link]="card.link"
            [hideLink]="hideLink()" />
    </div>
</big-ui-card>
